import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';

import { VERTICALS } from '../../constants/uriConstants';

const SbSharedTopTileControllerComponent = props => {
    return (
        <ServerVarsContextConsumer>
            {({ showRoomTiles }) => {
                const { searchBrowse } = props;
                const { browseContentModule, displayUriRef } = searchBrowse;
                const isTopFurnitureCategory = `/${VERTICALS.FURNITURE}/` === displayUriRef;
                const shouldShowRoomTiles = showRoomTiles && isTopFurnitureCategory;
                const showCategoryTiles = !shouldShowRoomTiles && !browseContentModule;

                return (
                    <React.Fragment>
                        {showCategoryTiles && props.categoryTiles}
                        {shouldShowRoomTiles && props.roomTiles}
                    </React.Fragment>
                );
            }}
        </ServerVarsContextConsumer>
    );
};

SbSharedTopTileControllerComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
    categoryTiles: PropTypes.node,
    roomTiles: PropTypes.node,
};

export const SbSharedTopTileController = createFragmentContainer(
    SbSharedTopTileControllerComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedTopTileController_searchBrowse on SearchBrowseQueryConnection {
                displayUriRef
                browseContentModule(contentModuleId: $contentModuleId) {
                    description
                }
            }
        `,
    }
);
